/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { toHeaderCase } from "js-convert-case";
import config from "../config/credential.config.json";
import _ from "lodash";
import moment from "moment";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_CREDENTIAL_DETAIL } from "../graphql";
import { VApplication } from "../../../application";

const parse = require("url-parse");

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface ICredentialMethods extends IPluginMethodMap {
  getCredentialProps(args: any): Promise<any>;
}

function isValidHttpUrl(string: string) {
  let url;

  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }

  return url.protocol === "http:" || url.protocol === "https:";
}

export class CredentialService implements IAgentPlugin {
  readonly methods: ICredentialMethods;

  constructor() {
    this.methods = {
      getCredentialProps: this.getProps.bind(this),
    };
  }

  async getProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    const url = parse(window.location.href, true);
    let credId;
    let orgId;
    if (url?.query?.tag) {
      credId = url.query.tag;
    }
    if (url?.query?.no) {
      orgId = url.query.no;
    }
    try {
      if (client) {
        const res = await client.query({
          query: GET_CREDENTIAL_DETAIL,
          variables: {
            verifyCredentialPublicId: credId,
          },
          fetchPolicy: "network-only",
          headers: {
            "org-id": orgId,
          },
        });
        if (res?.data) {
          return {
            data: res?.data?.verifyCredentialPublic,
            feedback:res?.data?.verifyCredentialPublic?.feedback,
            imageItems: this.formatImages(
              res?.data?.verifyCredentialPublic?.image
            ),
            logoSrc:  this.formatLogo(res?.data?.verifyCredentialPublic),
            title: this.formatTitle(res?.data?.verifyCredentialPublic),
            subtitle: this.formatSubTitle(res?.data?.verifyCredentialPublic),
            badgeTitle: res?.data?.verifyCredentialPublic?.approveStatus ?? res?.data?.verifyCredentialPublic?.status,
            badgeTitleBg: this.formatBadgeTitleBg(
              res?.data?.verifyCredentialPublic
            ),
            description: res?.data?.verifyCredentialPublic?.description,
            credential: this.formatAttributes(
              res?.data?.verifyCredentialPublic
            ),
            attributeItems: 
             this.formatAttributeItems(
              res?.data?.verifyCredentialPublic
            ),
            tableItems: this.formatDigitalSignatures(
              res?.data?.verifyCredentialPublic
            ),
            carouselItems: this.formatCarouselItems(
              res?.data?.verifyCredentialPublic
            ),
            listItemTitle: this.formatGetListItemTitle(res?.data?.verifyCredentialPublic),
          };
        }
      }
    } catch (err: any) {
      return err;
    }
  }

  private formatLogo(credential?:any) {
    if(credential?.signers){
      const lastEle = credential?.signers[credential?.signers.length - 1];
      const finalLogo = lastEle?.logo
      return finalLogo;
    }
    return credential?.issuerLogo





  }

  private formatAttributeItems(credential: any) {

    if (credential?.signers) {
     return this.formatAttributeItemsv1(credential)
    }
    
    const formatted: any = {
      title: config?.digitalSignatures?.title,
      info: config?.attributeItems,
    };
    if (credential) {
      for (let credKey in credential) {
        if (credKey === "issuer") {
          const index = _.findIndex(
            formatted.info,
            (info: any) => info.id === "digitalSignedBy"
          );
          if (index > -1) {
            formatted.info[index].value = credential[credKey];
          }
        } else if (credKey === "issuerDid") {
          const index = _.findIndex(
            formatted.info,
            (info: any) => info.id === "signerDID"
          );
          if (index > -1) {
            formatted.info[index].value = credential[credKey];
          }
        } else if (credKey === "issuerPk") {
          const index = _.findIndex(
            formatted.info,
            (info: any) => info.id === "signerPublicKey"
          );
          if (index > -1) {
            formatted.info[index].value = credential[credKey];
          }
        } else if (credKey === "validFrom") {
          const index = _.findIndex(
            formatted.info,
            (info: any) => info.id === "validFrom"
          );
          if (index > -1) {
            formatted.info[index].value = this.formatDate(credential[credKey]);
          }
        } else if (credKey === "validUntil") {
          const index = _.findIndex(
            formatted.info,
            (info: any) => info.id === "validUntil"
          );
          if (index > -1) {
            formatted.info[index].value = this.formatDate(credential[credKey]);
          }
        } else if (credKey === "status") {
          const index = _.findIndex(
            formatted.info,
            (info: any) => info.id === "status"
          );
          if (index > -1) {
            formatted.info[index].value = credential[credKey];
          }
        } else {
        }
      }
    }
    return formatted?.info;
  }

  private formatAttributeItemsv1(credential: any) {
    let _credential = {};
    if (credential?.signers) {
      _credential = credential.signers;
    }
    let ans: any = [];
    if (_credential) {
      // for (let item = 0; item < _credential.length; item++) {
      //   let temp = config?.attributeItems[0];
      //   for (let credKey in _credential[item]) {
      //     console.log("sds",_credential[item])
      //     if (credKey === "name") {
      //       temp = { ...temp, value: _credential[item][credKey]  };
      //     }
      //   }
      //   ans.push(temp);
      // }
      for (let item = _credential.length - 1; item < _credential.length; item++) {
        let temp = config?.attributeItems[0];
        for (let credKey in _credential[item]) {
          console.log("sds",_credential[item])
          if (credKey === "name") {
            temp = { ...temp, value: _credential[item][credKey]  };
          }
        }
        ans.push(temp);
      }
      console.log(ans, "ans->");
      let temp = config?.attributeItems;
      temp = temp
        .filter((item) => item.id !== "digitalSignedBy")
        .map((_item) => {
          if(_item.id === "validUntil"){
            return { ..._item, value: this.formatDate(
              credential[_item.id] ?? null
            ) };
          }
          if(_item.id === "validFrom"){
            return { ..._item, value: 
              credential[_item.id] 
             };
          }
          if(_item.id === "status"){
            return { ..._item, value: 
              credential[_item.id] 
             };
          }
          return { ..._item, value: credential[_item.id] };
        }
        
        );
      return [...ans, ...temp];
    }

    // else if (credKey === "did") {

    //   temp = temp.map((_item) => {
    //     if (_item.id === "signerDID") {
    //       return { ..._item, value: _credential[item][credKey] };
    //     }
    //     return _item;
    //   });

    // } else if (credKey === "pk") {
    //   temp = temp.map((_item) => {
    //     if (_item.id === "signerPublicKey") {
    //       return { ..._item, value: _credential[item][credKey] };
    //     }
    //     return _item;
    //   });

    // } else if (credKey === "createdAt") {
    //   temp = temp.map((_item) => {
    //     if (_item.id === "validFrom") {
    //       return {
    //         ..._item,
    //         value: this.formatFromDate(
    //           _credential[item][credKey] ?? null
    //         ),
    //       };
    //     }
    //     return _item;
    //   });

    // } else if (credKey === "validUntil") {
    //   temp = temp.map((_item) => {
    //     if (_item.id === "validUntil") {
    //       return {
    //         ..._item,
    //         value: this.formatFromDate(
    //           _credential[item][credKey] ?? null
    //         ),
    //       };
    //     }
    //     return _item;
    //   });

    // } else if (credKey === "status") {
    //   temp = temp.map((_item) => {
    //     if (_item.id === "status") {
    //       return { ..._item, value: _credential[item][credKey] };
    //     }
    //     return _item;
    //   });
    // }
    console.log("ans", ans);
    return ans;
  }



  private getWalletRegistered(credential: any) {
    let isWalletRegistered = false;

    if (credential?.accountStatus === "WALLET_REGISTERED") {
      isWalletRegistered = true;
    }

    return isWalletRegistered;
  }

  private formatAttributes(credential?: any) {
    let _attributeData: any = [];
    let formatted: any = { ...(credential?.credentialSubject || {}) };
    if (formatted) {
      for (let key in formatted) {
        if (config?.credentialSubject?.blacklistedKeys?.includes(key)) {
          delete formatted[key];
        }
      }
    }

    Object.entries(formatted).forEach(([key, value]) => {
      if (!Array.isArray(value)) {
        _attributeData.push({
          label: toHeaderCase(key ?? ""),
          value: value,
        });
      }
    });
    return _attributeData;
  }

  private formatBadgeTitleBg(credential?: any) {
    let formatted: any = "danger";
    if (credential?.status?.toLowerCase()?.includes("active")) {
      formatted = "success";
    }
    return formatted;
  }

  private formatTitle(credential: any) {
    let formatted = credential?.credentialName ?? "";
    return formatted;
  }

  private formatSubTitle(credential: any) {
    if(credential?.signers){
      const lastEle = credential?.signers[credential?.signers.length - 1];
      const finalSubTitle = lastEle?.name
      let formatted = finalSubTitle ?? "";
      return formatted;
    }
    else {
      let formatted = credential?.issuer ?? "";
      return formatted;
    }
 
  }

  private formatImages(image?: string) {
    const formatted: any = [];
    if (image) {
      formatted.push({
        original: `data:image/png;base64,${image}`,
        thumbnail: `data:image/png;base64,${image}`,
      });
    }
    return formatted;
  }

  private formatGetListItemTitle(credential:any) {
    if(credential?.signers){
      return this.formatGetListItem1Title(credential)
    }
    return [config?.digitalSignatures?.title]
  }

    private formatGetListItem1Title(credential: any) {
    let res = credential?.signers?.map((_signer) => {
      return _signer?.title;
    });
    return res;
  }

  private formatDigitalSignatures(credential: any) {
    if(credential?.signers){
      return this.formatDigitalSignaturesV1(credential)
    }

    const formatted: any = {
      // title: [config?.digitalSignatures?.title],
      info: config?.digitalSignatures?.info,
    };
    if (credential) {
      for (let credKey in credential) {
        if (credKey === "issuer") {
          const index = _.findIndex(
            formatted.info,
            (info: any) => info.id === "digitalSignedBy"
          );
          if (index > -1) {
            formatted.info[index].value = credential[credKey];
          }
        } else if (credKey === "issuerDid") {
          const index = _.findIndex(
            formatted.info,
            (info: any) => info.id === "signerDID"
          );
          if (index > -1) {
            formatted.info[index].value = credential[credKey];
          }
        } else if (credKey === "issuerPk") {
          const index = _.findIndex(
            formatted.info,
            (info: any) => info.id === "signerPublicKey"
          );
          if (index > -1) {
            formatted.info[index].value = credential[credKey];
          }
        } else if (credKey === "validFrom") {
          const index = _.findIndex(
            formatted.info,
            (info: any) => info.id === "validFrom"
          );
          if (index > -1) {
            formatted.info[index].value = this.formatDate(credential[credKey]);
          }
        } else if (credKey === "validUntil") {
          const index = _.findIndex(
            formatted.info,
            (info: any) => info.id === "validUntil"
          );
          if (index > -1) {
            formatted.info[index].value = this.formatDate(credential[credKey]);
          }
        } else if (credKey === "status") {
          const index = _.findIndex(
            formatted.info,
            (info: any) => info.id === "status"
          );
          if (index > -1) {
            formatted.info[index].value = credential[credKey];
          }
        } else {
        }
      }
    }
    return [formatted?.info];
  }



  private formatDigitalSignaturesV1(credential: any) {

    let _credential = {};
    if (credential.signers) {
      _credential = credential.signers;
    }
    let ans: any = [];
    if (_credential) {
      for (let item = 0; item < _credential.length; item++) {
        let temp = config.digitalSignaturesv1?.info;
        for (let credKey in _credential[item]) {
          if (credKey === "createdAt") {
            temp = temp.map((_item) => {
              if (_item.id === "createdAt") {
                return {
                  ..._item,
                  value: this.formatFromDate(
                    _credential[item][credKey] ?? null
                  ),
                };
              }
              return _item;
            });
          } else if (credKey === "did") {
            temp = temp.map((_item) => {
              if (_item.id === "did") {
                return { ..._item, value: _credential[item][credKey] };
              }
              return _item;
            });
          } else if (credKey === "pk") {
            temp = temp.map((_item) => {
              if (_item.id === "pk") {
                return { ..._item, value: _credential[item][credKey] };
              }
              return _item;
            });
          } else if (credKey === "name") {
            temp = temp.map((_item) => {
              if (_item.id === "name") {
                return { ..._item, value: _credential[item][credKey] };
              }
              return _item;
            });
          } else if (credKey === "address") {
            temp = temp.map((_item) => {
              if (_item.id === "address") {
                return { ..._item, value: _credential[item][credKey] };
              }
              return _item;
            });
          } else if (credKey === "isValid") {
            temp = temp.map((_item) => {
              if (_item.id === "isValid") {
                return {
                  ..._item,
                  value: _credential[item][credKey] ? "VALID" : "INVALID",
                };
              }
              return _item;
            });
          } else {
          }
        }
        ans = [...ans, [...temp]];
        console.log("ansss",ans)
      }
    }
    return ans;
  }

  private formatDate(date: string) {
    if (date) {
      return moment(date).format("lll");
    } else {
      return "Perpetual";
    }
  }

  private formatFromDate(date: string) {
    if (date) {
      return moment(date).format("lll");
    } else {
      return "-";
    }
  }

  private formatCarouselItems(credential: any) {
    let _docs: any = [];
    if (credential?.pdf) {
      const src = isValidHttpUrl(credential?.pdf)
        ? credential?.pdf
        : `data:application/pdf;base64,${credential?.pdf}`;
      _docs.push({
        type: "pdf",
        poster: credential?.logo,
        src: src,
        title: credential?.credentialName,
      });
    }
    Object.entries(credential?.credentialSubject).forEach(([key, value]) => {
      if (Array.isArray(value) && value?.length > 0) {
        value.forEach((key) => {
          if (key?.type && key?.file) {
            let _type = key?.type?.split("/");
            _docs.push({
              type:
                _type[0] === "image"
                  ? "img"
                  : _type[0] === "video"
                  ? "video"
                  : _type[0] === "audio"
                  ? "audio"
                  : "pdf",
              poster: credential?.logo,
              src: key?.base64,
              title: credential?.credentialName,
            });
          }
        });
      }
    });

    Array.isArray(credential?.evidence) &&
      credential?.evidence.map((item: any) => {
        let _type = item?.evidenceDocumentType?.split("/");
        _docs.push({
          type:
            _type[0] === "image"
              ? "img"
              : _type[0] === "video"
              ? "video"
              : _type[0] === "audio"
              ? "audio"
              : "pdf",
          poster: item?.poster,
          src: item?.id,
          title: item?.evidenceDocument?.replace(/\.[^/.]+$/, ""),
        });
      });
    return _docs;
  }
}
